/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Contract_Duration_RangeInputs */

const en_clients_validation_contract_duration_range = /** @type {(inputs: Clients_Validation_Contract_Duration_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration must be a positive whole number of months.`)
};

const pt_br2_clients_validation_contract_duration_range = /** @type {(inputs: Clients_Validation_Contract_Duration_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A duração deve ser um número inteiro de meses positivo.`)
};

/**
* | output |
* | --- |
* | "Duration must be a positive whole number of months." |
*
* @param {Clients_Validation_Contract_Duration_RangeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_contract_duration_range = /** @type {((inputs?: Clients_Validation_Contract_Duration_RangeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Contract_Duration_RangeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_contract_duration_range(inputs)
	return pt_br2_clients_validation_contract_duration_range(inputs)
});